/**
 * The workspace-tabs chrome marks its DOM root with `data-workspace-tabs` so
 * overlay layers can recognize interactions with it. A click on a workspace
 * tab must switch workspaces, not dismiss the open dialog as an
 * outside-interaction — per-tab state decides what the target workspace
 * shows.
 */
export function isWorkspaceTabsInteraction(
  target: EventTarget | null,
): boolean {
  return (
    target instanceof Element &&
    target.closest('[data-workspace-tabs]') !== null
  )
}
